import { TAccountLinkData, TAccountLink } from '@newo/api/gateway';
// components
import MembersTable from '@/pages/Profile/components/Members/components/MembersTable';
// utils
import { openConfirmDeleteModal } from '@/utils/ui.tsx';
import {
    useCustomerAccountLinksQuery,
    useDeleteAccountLinkMutation,
    useCreateAccountLinkMutation,
    useUpdateAccountLinkMutation
} from '@/services/customer/customer/customer.queries';

const Members = () => {
    const { data, refetch, isLoading, isSuccess } =
        useCustomerAccountLinksQuery({
            page: 1,
            per: 100
        });

    const { mutateAsync: deleteAccountLink } = useDeleteAccountLinkMutation();
    const { mutateAsync: createAccountLink } = useCreateAccountLinkMutation();
    const { mutateAsync: updateAccountLink } = useUpdateAccountLinkMutation();

    const members = (data?.items ?? []).filter(
        (member) => member.role !== 'referral'
    );

    const handleDelete = (member: TAccountLink) => {
        openConfirmDeleteModal({
            title: `Unlink ${member.email}`,
            children: <>Are you sure you want to unlink {member.email}?</>,
            confirmLabel: 'Unlink',
            onConfirm: () => {
                deleteAccountLink({
                    accountId: member.account_id
                })
                    .then(async () => refetch())
                    .catch(console.error);
            }
        });
    };

    const handleSubmit = async (
        formData: TAccountLinkData,
        accountId?: string
    ) => {
        await (accountId
            ? updateAccountLink({
                  accountId,
                  data: formData
              })
                  .then(async () => refetch())
                  .catch(console.error)
            : createAccountLink({
                  data: formData
              })
                  .then(async () => refetch())
                  .catch(console.error));
    };

    return (
        <MembersTable
            isLoading={isLoading}
            isSuccess={isSuccess}
            members={members}
            onDelete={handleDelete}
            onSubmit={handleSubmit}
        />
    );
};

export default Members;
